import { Typography } from 'antd'
import { infoApi } from 'common/api/entitiesApi'
import { parseBuildInfo } from 'common/components/AppVersionCheck'
import { useEffect, useState } from 'react'

const UNKNOWN_VERSION = 'dev'

const loadFrontendVersion = async (): Promise<string | undefined> => {
  try {
    const response = await fetch(`/version.js?time=${Date.now()}`, { cache: 'no-store' })
    return response.ok ? parseBuildInfo(await response.text()) : undefined
  } catch {
    return undefined
  }
}

export const BuildVersions = () => {
  const [frontendVersion, setFrontendVersion] = useState<string>()
  const [backendVersion, setBackendVersion] = useState<string>()

  useEffect(() => {
    void loadFrontendVersion().then(setFrontendVersion)
    infoApi
      .buildInfo()
      .then((info) => setBackendVersion(info.version))
      .catch(() => undefined)
  }, [])

  return (
    <Typography.Text type="secondary" style={{ fontSize: 12, fontWeight: 'normal' }}>
      Frontend: {frontendVersion || UNKNOWN_VERSION} · Backend: {backendVersion || UNKNOWN_VERSION}
    </Typography.Text>
  )
}
